import { uniq } from 'lodash'
import { useState } from 'react'

const getSubItems = (lineItem: ISubItem): Array<ISubItem> =>
  (lineItem.subItems || []).flatMap((subItem) => [subItem, ...getSubItems(subItem)])

export const useSelection = () => {
  const [selectedItems, setSelectedItems] = useState<ILineItem[]>([])
  const resetSelection = () => setSelectedItems([])

  const onCheck = (checked: boolean, lineItem: ILineItem) => {
    // select sub items which are not vacant and not free attachments
    const selectableSubItems = getSubItems(lineItem).filter(
      (item) => !(item.freeAttachment || item.vacant)
    )

    if (checked) {
      // select sub items
      setSelectedItems(uniq([...selectedItems, lineItem, ...selectableSubItems]))
    } else {
      // remove selection of sub items
      const removeItems = [lineItem, ...selectableSubItems]
      setSelectedItems(selectedItems.filter((item) => !removeItems.includes(item)))
    }
  }

  return { onCheck, resetSelection, selectedItems }
}
